
import { defineComponent, ref, Ref, watch, inject } from 'vue';
export default defineComponent({
  name: 'PassengerPicker',
  props: {
    prop: String,
    passengerInfo: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup(props, context) {
    //乘客（成人，儿童，婴儿）人数
    const num: Ref<number[]> = ref(
      inject(
        'num',
        ref<number[]>([0, 0, 0])
      )
    );
    watch(num.value, () => {
      let s: String = '';
      if (num.value[0] != 0) {
        s += '成人 ' + num.value[0] + '  ';
      }
      if (num.value[1] != 0) {
        s += '儿童 ' + num.value[1] + '  ';
      }
      if (num.value[2] != 0) {
        s += '婴儿 ' + num.value[2];
      }
      context.emit('update:passengerInfo', s);
    });
    return {
      num,
    };
  },
});
